import React from "react";
import { Grid, TextField, MenuItem, Button } from "@mui/material";

interface Props {
  sessions: { id: string; name: string }[];
  filters: { sessionId?: string; module?: string; dateFrom?: string; dateTo?: string };
  onChange: (next: { sessionId?: string; module?: string; dateFrom?: string; dateTo?: string }) => void;
  onSearch: () => void;
  onReset: () => void;
}

const StudentHistoryFilters: React.FC<Props> = ({ sessions, filters, onChange, onSearch, onReset }) => {
  const f = (name: string, value: any) => onChange({ ...filters, [name]: value });
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={3}>
        <TextField select fullWidth label="Session" value={filters.sessionId || ""} onChange={(e) => f("sessionId", e.target.value)}>
          <MenuItem value="">All</MenuItem>
          {sessions.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField select fullWidth label="Module" value={filters.module || ""} onChange={(e) => f("module", e.target.value)}>
          <MenuItem value="">All</MenuItem>
          <MenuItem value="STUDENT">STUDENT</MenuItem>
          <MenuItem value="HOUSE_ASSIGN">HOUSE_ASSIGN</MenuItem>
          <MenuItem value="SUBJECT_ASSIGN">SUBJECT_ASSIGN</MenuItem>
          <MenuItem value="SESSION_TRANSFER">SESSION_TRANSFER</MenuItem>
          <MenuItem value="GATE_PASS">GATE_PASS</MenuItem>
          <MenuItem value="CERTIFICATE">CERTIFICATE</MenuItem>
          <MenuItem value="STUDENT_LOG">STUDENT_LOG</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField label="From" type="date" fullWidth value={filters.dateFrom || ""} onChange={(e) => f("dateFrom", e.target.value)} InputLabelProps={{ shrink: true }} />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField label="To" type="date" fullWidth value={filters.dateTo || ""} onChange={(e) => f("dateTo", e.target.value)} InputLabelProps={{ shrink: true }} />
      </Grid>
      <Grid item xs={12} md={3}>
        <Button fullWidth variant="contained" onClick={onSearch}>
          Search
        </Button>
      </Grid>
      <Grid item xs={12} md={3}>
        <Button fullWidth onClick={onReset}>Reset</Button>
      </Grid>
    </Grid>
  );
};

export default StudentHistoryFilters;
